export const HASHED_PASSWORD = '$2a$12$RtpcExaeyNlojPvLhydupucCrwFQtchoYChTr0srHdyy8Vw3OmekC';
